module.exports = __webpack_public_path__ + "fonts/iconfont.83d73b2b.woff2";